var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-phone-formatter"},[_c('a',{attrs:{"href":_vm._f("phoneFormatter")(_vm.phoneNumber)}},[_vm._v(_vm._s(_vm.phoneNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }